import { render, staticRenderFns } from "./conversation-item.vue?vue&type=template&id=778b08ec&scoped=true"
import script from "./conversation-item.vue?vue&type=script&lang=js"
export * from "./conversation-item.vue?vue&type=script&lang=js"
import style0 from "./conversation-item.vue?vue&type=style&index=0&id=778b08ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778b08ec",
  null
  
)

export default component.exports